<template>
	<div>
		<div class="top_box">
			<h2>{{langtrans().ywcajg[languageIndex]}}</h2>
			<!-- ========== 优化后的筛选区域 ========== -->
			<div class="filter-container">
				<div class="filter-row">
					<div class="filter-item">
						<label class="filter-label">{{langtrans().qssjj[languageIndex]}}</label>
						<el-date-picker 
							@change="sttime()" 
							v-model="st_time" 
							align="right" 
							type="date" 
							:placeholder="langtrans().qssjj[languageIndex]" 
							:picker-options="pickerOptions1"
							class="filter-date-picker">
						</el-date-picker>
					</div>
					<div class="filter-item">
						<label class="filter-label">{{langtrans().jjssjj[languageIndex]}}</label>
						<el-date-picker 
							@change="entime()" 
							v-model="en_time" 
							align="right" 
							type="date" 
							:placeholder="langtrans().jjssjj[languageIndex]" 
							:picker-options="pickerOptions1"
							class="filter-date-picker">
						</el-date-picker>
					</div>
					<div class="filter-item">
						<label class="filter-label">{{langtrans().ajbh[languageIndex]}}</label>
						<el-input 
							v-model="caseNumber" 
							:placeholder="langtrans().ajbh[languageIndex]" 
							class="filter-input">
						</el-input>
					</div>
				</div>
				<div class="button-row">
					<div class="button-group">
						<el-button type="primary" plain @click="filt()" class="filter-btn">
							{{langtrans().czx[languageIndex]}}
						</el-button>
						<el-button type="primary" @click="caseexport()" class="export-btn">
							导出结果数据
						</el-button>
						<span class="export-records-link" @click="Exportrecords()">
							导出记录
						</span>
					</div>
				</div>
			</div>
			<!-- ========== 优化后的筛选区域结束 ========== -->
		</div>
		<div class="form_box">
			<el-table :empty-text="langtrans().zwmsss[languageIndex]" :data="tableData" border>
				<el-table-column prop="number" :label="langtrans().xhh[languageIndex]" min-width="50">
				</el-table-column>
				<el-table-column  :label="langtrans().ajbhh[languageIndex]" min-width="70">
          <template slot-scope="scope">
            {{scope.row.casenumber}}
            <span v-if="scope.row.subRegulatorId != null && scope.row.subRegulatorId != '' && scope.row.subRegulatorId != undefined">({{scope.row.subRegulatorId}})</span>
          </template>
				</el-table-column>
				<el-table-column prop="address" :label="langtrans().ffsddd[languageIndex]" min-width="140">
				</el-table-column>
				<el-table-column prop="username" :label="langtrans().yhxm[languageIndex]" min-width="60">
				</el-table-column>
				<el-table-column prop="phone" :label="langtrans().yhsjhh[languageIndex]" min-width="70">
				</el-table-column>
				<el-table-column prop="papers" :label="langtrans().zjxsxx[languageIndex]" min-width="90">
				</el-table-column>
				<el-table-column prop="sex" :label="langtrans().xbb[languageIndex]" min-width="50">
				</el-table-column>
				<el-table-column prop="time" :label="langtrans().cxsjj[languageIndex]" min-width="90">
				</el-table-column>
				<el-table-column v-if="$route.query.typeId != 800" prop="par" :label="langtrans().yhbxxq[languageIndex]" min-width="90">
					<template slot-scope="scope">
						<el-button type="text" size="small" v-show="scope.row.isshow" @click="toUrl(scope.row.insuranceUrl)">{{langtrans().bxxqq[languageIndex]}}</el-button>
						<el-button type="text" size="small" v-show="!scope.row.isshow">{{langtrans().wm[languageIndex]}}</el-button>
					</template>
				</el-table-column>
				<el-table-column prop="plan" :label="langtrans().ddqjdd[languageIndex]" min-width="60">
				</el-table-column>
				<el-table-column prop="node" :label="langtrans().ddqjjd[languageIndex]" min-width="60">
				</el-table-column>
				<el-table-column prop="get_time" :label="langtrans().hfsjj[languageIndex]" min-width="90">
				</el-table-column>
				<el-table-column prop="op" :label="langtrans().cczzz[languageIndex]" min-width="100">
					<template slot-scope="scope">
						<el-button type="text" size="small" @click="tores(scope.row.caseid)">{{langtrans().jyxqq[languageIndex]}}</el-button>
					</template>
				</el-table-column>
			</el-table>
      <el-pagination
      style="margin-top: 15px;float: right;"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage4"
      :page-sizes="[20]"
      :page-size="20"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total">
    </el-pagination>
		</div>
	</div>
</template>

<script>
	import langtrans from "./js/finish.vue.trans.js";
	import "isomorphic-fetch";
	import constants from "@/util/constants.js";
	import Promise from 'promise-polyfill';
	// ========== 新增导入API ==========
	import { getFinishCase, exportFinishCaseList } from '@/views/axios/api.js';
	// ========== 新增导入API结束 ==========
	if(!window.Promise) {
		window.Promise = Promise;
	}
	export default {
		data() {
			return {
        start:0,
        count:20,
        total:0,
        currentPage4: 1,
				tableData: [],
				token: this.$route.params.token ||
					JSON.parse(window.localStorage.getItem("data")).data,
				shortcuts: [{
						text: "今天",
						onClick(picker) {
							picker.$emit("pick", new Date());
						}
					},
					{
						text: "昨天",
						onClick(picker) {
							const date = new Date();
							date.setTime(date.getTime() - 3600 * 1000 * 24);
							picker.$emit("pick", date);
						}
					},
					{
						text: "一周前",
						onClick(picker) {
							const date = new Date();
							date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
							picker.$emit("pick", date);
						}
					}
				],
				st_time: "",
				en_time: "",
				caseNumber: "",
				usertype: JSON.parse(window.localStorage.getItem("usertype")).data,
				parArray: ["FinishPar1", "ComFinishPar", "RegFinishPar"],
				pickerOptions1: {
					disabledDate(time) {
						return time.getTime() > Date.now();
					}
				}
			};
		},
		methods: {
			// ========== 新增导出功能方法 ==========
			/**
			 * 导出案件结果数据
			 * 使用专门为finish.vue设计的简化接口
			 */
			caseexport() {
				// 处理时间参数
				let stTime = this.st_time;
				let enTime = this.en_time;
				
				if(stTime == null) {
					stTime = '';
				}
				if(enTime == '' || enTime == null) {
					enTime = '';
				} else {
					enTime = enTime + 24 * 60 * 60 * 1000 - 1;
				}
				
				// 构建导出参数 - 简化版本，只包含finish.vue需要的参数
				var obj = {
					token: JSON.parse(window.localStorage.getItem("data")).data,
					incidentType: this.$route.query.typeId || '', // 使用当前页面的类型ID
					startTs: stTime,
					endTs: enTime,
					caseNo: this.caseNumber,
					// 设置状态为已完成的案件状态
					statustxt: "&status=110&status=111&status=113&status=190"
				};
				
				console.log('导出参数:', obj);
				
				// 调用新的简化导出API
				exportFinishCaseList(obj).then((res) => {
					if(res.data.code == 0) {
						this.$message({
							showClose: true,
							message: "请去导出记录中下载",
							type: "success",
						});
					} else {
						this.$message.error(res.data.msg || "导出失败");
					}
				}).catch((error) => {
					console.error('导出错误:', error);
					this.$message.error("导出失败");
				});
			},
			
			/**
			 * 跳转到导出记录页面
			 * 传递finish.vue页面的筛选项参数
			 */
			Exportrecords() {
				// 处理时间参数
				let stTime = this.st_time;
				let enTime = this.en_time;
				
				if(stTime == null) {
					stTime = '';
				}
				if(enTime == '' || enTime == null) {
					enTime = '';
				} else {
					enTime = enTime + 24 * 60 * 60 * 1000 - 1;
				}
				
				// 构建查询参数，传递finish.vue的筛选项
				const queryParams = {
					typeId: this.$route.query.typeId || 800,
					startTs: stTime,
					endTs: enTime,
					caseNo: this.caseNumber || '',
					// 传递已完成案件的状态
					status: '110,111,113'
				};
				
				// 过滤空值参数
				Object.keys(queryParams).forEach(key => {
					if (queryParams[key] === '' || queryParams[key] === null || queryParams[key] === undefined) {
						delete queryParams[key];
					}
				});
				
				console.log('导出记录查询参数:', queryParams);
				
				this.$router.push({
					name: 'Exportrecords',
					query: queryParams
				});
			},
			// ========== 新增导出功能方法结束 ==========
			
        handleSizeChange(val) {
         this.count = val
             this.getData()
        console.log(`每页 ${val} 条`);
      },
      handleCurrentChange(val) {
        this.start = (val-1) * this.count;
        // this.start = val * 10
            this.getData()
        console.log(`当前页: ${val}`);
      },
			setTxt(str,status){
				return constants.setTxt(str,status,true)
			},				
			langtrans() {
				return langtrans
			},
			tores(obj) {
				this.$router.push({
					name: this.parArray[this.usertype],
					params: {
						token: this.token
					},
					query: {
						caseid: obj,
						typeId: this.$route.query.typeId
					}
				});
			},
			sttime() {
				this.st_time = this.st_time * 1;
				// this.getData(this.st_time, 0);
				// console.log(this.st_time);
			},
			entime() {
				this.en_time = this.en_time * 1;
				// this.getData(0, this.en_time);
			},
			filt() {
				let endTime = this.en_time;
				if (endTime) {
					endTime = endTime + 86400000;
				}
				this.getData(this.st_time, endTime);
			},
			toUrl(url) {
				window.open(url);
			},
			getData(st, et) {
				this.tableData = [];
				let that = this;
				let n = 0;
				let sex = "";
				let isshow = false;
				let stTime = st || this.st_time;
				let enTime = et || this.en_time;

				let tl = '';
				if(stTime && enTime) {
					tl = tl + `&startTs=${stTime}&endTs=${enTime}`;
				} else if(stTime) {
					tl = tl + `&startTs=${stTime}`;
				} else if(enTime) {
					tl = tl + `&endTs=${enTime}`;
				}
				var data = null;
				if(this.$route.query.typeId != undefined) {
					data = {
						token: this.token,
						typeId: this.$route.query.typeId,
						start:this.start,
						count:this.count,
						caseNo:this.caseNumber		
					}
					if(stTime) {
						data.startTs = stTime;
					}
					if(enTime) {
						data.endTs = enTime;
					}
				} else {
					data = {
						token: this.token,
						start:this.start,
						count:this.count,
						caseNo:this.caseNumber		
					}
					if(stTime) {
						data.startTs = stTime;
					}
					if(enTime) {
						data.endTs = enTime;
					}
				}
				getFinishCase(data)
					.then(function(data) {
						that.tableData=[]
						var data = data.data
            console.log(data)
            that.total = data.total
						if(data.obj) {
							var plan = "";
							data.obj.map(v => {
								n = n + 1;
								if(that.languageIndex == 0){
									if(v.victimList[0].obj.gender == 1) {//汉语
										sex = "男";
									} else {
										sex = "女";
									}										
								}else{
									if(v.victimList[0].obj.gender == 1) {//汉语
										sex = "Male";
									} else {
										sex = "Female";
									}										
								}
								if(
									v.victimList[0].obj.insurancePolicyNo &&
									v.victimList[0].obj.insurancePolicyNo != ""
								) {
									isshow = true;
								} else {
									isshow = false;
								}
								var pt = constants.pt2txt(v.obj.caseState);
								var phone = v.victimList[0].obj.victimName;
								var username = v.victimList[0].obj.victimName;
								if(that.languageIndex == 1){									
									pt.phase = pt.phaseEn
									pt.node = pt.nodeEn
								}
								var address=''
									if(v.generalLocation){
										if(!constants.setTxt(v.generalLocation.addr,'zh')){
											address=v.generalLocation.addr
										}else{
											address=that.languageIndex== 0 ? constants.setTxt(v.generalLocation.addr,'zh') : constants.setTxt(v.generalLocation.addr,'en')
										}
									}																	
								that.tableData.push({
									caseid: v.obj.id,
									number: n, //序号
									casenumber: v.obj.caseNo, //案件编号
									address, //地址
									username: username, //姓名
									phone: phone, //联系方式
									papers: v.victimList[0].obj.idNo || "无", //身份证号
									sex: sex, //性别
									time: constants.time(v.obj.incidentTs), //出险时间
									isshow: isshow, //保单
									plan: pt.phase, //进度
									node: pt.node, //节点
									get_time: constants.time(v.rInstiFeedbackTs),
                  subRegulatorId: v.obj.subRegulatorId,
									op: "查看并操作",
									insuranceUrl: v.victimList[0].obj.insurancePaper, //用户保险详情链接
								});
								that.caseid = v.obj.id;
								// console.log(that.obj)
								// that.obj.push(v.obj);
								// that.victimList.push(v.victimList[0]);
							});
						}
					});
			},

		},

		computed: {
			languageIndex() {
				return this.$store.state.language
			}
		},
		mounted() {
			this.getData();
		},
		watch:{
			// caseNumber(nv, ov) {
			// 	console.log('案件编号变化:', nv);
			// 	this.getData();
			// },
			languageIndex(){
				this.getData();
			}
		}
	};
</script>

<style scoped>
	@import url("../../css/table.css");
	
	/* ========== 优化后的筛选区域样式 ========== */
	.filter-container {
		background: #f8f9fa;
		border-radius: 8px;
		padding: 20px;
		margin-bottom: 20px;
		box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
	}
	
	.filter-row {
		display: flex;
		flex-wrap: wrap;
		gap: 20px;
		margin-bottom: 20px;
		align-items: end;
	}
	
	.filter-item {
		display: flex;
		flex-direction: column;
		min-width: 200px;
		flex: 1;
	}
	
	.filter-label {
		font-size: 14px;
		color: #606266;
		margin-bottom: 8px;
		font-weight: 500;
	}
	
	.filter-date-picker,
	.filter-input {
		width: 100%;
	}
	
	.button-row {
		display: flex;
		justify-content: flex-end;
		align-items: center;
		padding-top: 10px;
		border-top: 1px solid #e4e7ed;
	}
	
	.button-group {
		display: flex;
		align-items: center;
		gap: 12px;
		flex-wrap: wrap;
	}
	
	.filter-btn {
		background: #409eff;
		border-color: #409eff;
		color: white;
		padding: 10px 20px;
		border-radius: 4px;
		transition: all 0.3s ease;
	}
	
	.filter-btn:hover {
		background: #66b1ff;
		border-color: #66b1ff;
	}
	
	.export-btn {
		background: #67c23a;
		border-color: #67c23a;
		color: white;
		padding: 10px 20px;
		border-radius: 4px;
		transition: all 0.3s ease;
	}
	
	.export-btn:hover {
		background: #85ce61;
		border-color: #85ce61;
	}
	
	.export-records-link {
		color: #409eff;
		cursor: pointer;
		font-size: 14px;
		padding: 10px 15px;
		border-radius: 4px;
		transition: all 0.3s ease;
		white-space: nowrap;
	}
	
	.export-records-link:hover {
		background: #ecf5ff;
		color: #66b1ff;
		text-decoration: none;
	}
	
	/* 响应式设计 */
	@media (max-width: 1200px) {
		.filter-row {
			gap: 15px;
		}
		
		.filter-item {
			min-width: 180px;
		}
	}
	
	@media (max-width: 768px) {
		.filter-container {
			padding: 15px;
		}
		
		.filter-row {
			flex-direction: column;
			gap: 15px;
		}
		
		.filter-item {
			min-width: auto;
			width: 100%;
		}
		
		.button-row {
			justify-content: center;
		}
		
		.button-group {
			flex-direction: column;
			width: 100%;
			gap: 10px;
		}
		
		.filter-btn,
		.export-btn {
			width: 100%;
			max-width: 200px;
		}
		
		.export-records-link {
			text-align: center;
			width: 100%;
			max-width: 200px;
		}
	}
	
	@media (max-width: 480px) {
		.filter-container {
			padding: 10px;
			margin-bottom: 15px;
		}
		
		.filter-label {
			font-size: 13px;
		}
		
		.filter-btn,
		.export-btn {
			font-size: 14px;
			padding: 8px 16px;
		}
		
		.export-records-link {
			font-size: 13px;
			padding: 8px 12px;
		}
	}
	/* ========== 优化后的筛选区域样式结束 ========== */
</style>


// WEBPACK FOOTER //
// src/components/fac/finish.vue